import { Popover as BootstrapPopover, OverlayTrigger } from 'react-bootstrap';

interface IWarningSignProps {
  text: string;
}

function WarningSign({ text }: IWarningSignProps) {
  return (
    <OverlayTrigger
      trigger={['hover', 'focus']}
      placement="bottom"
      overlay={
        <BootstrapPopover id="popover-basic">
         {text}
        </BootstrapPopover>
      }
    >
      <div style={{ marginRight: '10px', color: '#ff9800' }}>
        <i className="fa fa-exclamation-triangle" aria-hidden="true"></i>
      </div>
    </OverlayTrigger>
  );
}

export default WarningSign;
